import React from "react";
import { Users, Package, Warehouse, LayoutGrid } from "lucide-react";

const TrustBar = () => {
  const stats = [
    { label: "Daily Orders", value: "21,000", icon: Package },
    { label: "Distribution Hubs", value: "4 UK", icon: Warehouse },
    { label: "Storage Capacity", value: "200k+ Sq Ft", icon: LayoutGrid },
    { label: "Happy Customers", value: "1M+", icon: Users },
  ];

  return (
    <div className="w-full bg-dreibach-card border-y border-white/5 py-8 overflow-hidden">
      <div className="container mx-auto px-6">
        <div className="flex flex-wrap justify-between items-center gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="flex items-center gap-4 min-w-[200px]">
              <div className="w-2 h-2 rounded-full bg-dreibach-teal animate-pulse" />
              <div>
                <p className="text-xl font-black text-white tracking-tighter leading-none">
                    {stat.value}
                </p>
                <p className="text-xs uppercase tracking-widest text-gray-500 font-bold mt-1">
                    {stat.label}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustBar;
